import { ChevronDown } from "lucide-react";
import Reveal from "@/components/Reveal";

const QA = [
  { q: "Est-ce adapté aux débutantes ?", a: "Oui, les niveaux sont réglables et permettent de commencer doucement, à votre rythme." },
  { q: "Que contient le colis ?", a: "La plateforme, une télécommande, deux élastiques de résistance et un guide de démarrage." },
  { q: "Comment fonctionne le retour ?", a: "Vous disposez de 30 jours pour changer d'avis, avec retour gratuit." },
];

export default function Faq() {
  return (
    <section className="vf-faq" id="faq">
      <Reveal>
        <p className="vf-kicker">Une question ?</p>
        <h2 className="vf-h2">Nous sommes là<br /><em>pour vous aider.</em></h2>
      </Reveal>
      <Reveal className="vf-faq-list" delay={0.15}>
        {QA.map((item) => (
          <details key={item.q}>
            <summary>{item.q}<ChevronDown size={18} /></summary>
            <p>{item.a}</p>
          </details>
        ))}
      </Reveal>
    </section>
  );
}
